import React, { useEffect } from "react"

import {
  javascript,
  html,
  react,
  css,
  webpack,
  vscode,
  git,
  ubuntu,
  python,
  r,
  maxqda,
} from "../../utils/svgs"
import { ScrollRevealObject } from "../../types/scrollreveal"
import { Technology } from "./types"
import { TechnologyItem } from "./TechnologyItem"

const frontEnd: Technology[] = [
  {
    title: "HTML",
    svg: html,
    href: "https://developer.mozilla.org/en-US/docs/Web/HTML",
  },
  {
    title: "CSS",
    svg: css,
    href: "https://developer.mozilla.org/en-US/docs/Web/CSS",
  },
  {
    title: "JavaScript",
    svg: javascript,
    href: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },

  { title: "React", svg: react, href: "https://www.reactjs.org" },
]

const backEnd: Technology[] = [
  {
    title: "R",
    svg: r,
    href: "https://www.r-project.org/",
  },
  {
    title: "Python",
    svg: python,
    href: "https://www.python.org/",
  },
  {
    title: "MAXQDA",
    svg: maxqda,
    href: "https://www.maxqda.com/",
  },
]

const tools: Technology[] = [
  { title: "Webpack", svg: webpack, href: "https://webpack.js.org" },
  { title: "Git", svg: git, href: "https://git-scm.com/" },
  { title: "Ubuntu", svg: ubuntu, href: "https://ubuntu.com/" },
  { title: "VS Code", svg: vscode, href: "https://code.visualstudio.com/" },
]
const createTechnology = ({ title, svg, href }: Technology) => (
  <TechnologyItem key={title} svg={svg} title={title} href={href} />
)

export const Technologies = () => {
  useEffect(() => {
    // have to require here as importing at top breaks SSR
    // eslint-disable-next-line
    const ScrollReveal = require("scrollreveal").default as ScrollRevealObject

    ScrollReveal().reveal(".technologies a, .technologies h3", {
      duration: 600,
      distance: "20px",
      easing: "cubic-bezier(0.5, -0.01, 0, 1.005)",
      origin: "left",
      interval: 75,
    })

    return () => ScrollReveal().destroy()
  }, [])

  return (
    <div className="technologies">
      <h1 className="technologies__title">Teknolojiler</h1>
      <div>
        <h3>Front End</h3>
        <div className="technologies__row">
          {frontEnd.map(createTechnology)}
        </div>
      </div>

      <div>
        <h3>Veri Analizi & İstatistik</h3>
        <div className="technologies__row">{backEnd.map(createTechnology)}</div>
      </div>

      <div>
        <h3>DevOps & Araçlar</h3>
        <div className="technologies__row">{tools.map(createTechnology)}</div>
      </div>
    </div>
  )
}
